// Personal details must never sit in a URL. The website's main form used to
// hand them over as ?first_name=&last_name=&email=&phone_number= — an inline
// script in public/index.html strips them before GTM loads (page_location),
// and stripPersonalParams() below does the same again on app start in case
// that script didn't run. The values are kept in sessionStorage only, to
// prefill the order form, and are never put back into a URL.

export const PERSONAL_PARAMS = ["first_name", "last_name", "email", "phone_number", "mobile"];
const STORAGE_KEY = "t2d_prefill";

function readStored() {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
  } catch (e) {
    return {};
  }
}

function writeStored(value) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  } catch (e) {
    // Storage blocked: keep them for this page view only
    window.__t2dPrefill = value;
  }
}

export function stripPersonalParams() {
  let url;
  try {
    url = new URL(window.location.href);
  } catch (e) {
    return;
  }
  const found = {};
  let changed = false;
  PERSONAL_PARAMS.forEach((name) => {
    if (url.searchParams.has(name)) {
      const value = url.searchParams.get(name);
      if (value) found[name] = value;
      url.searchParams.delete(name);
      changed = true;
    }
  });
  if (!changed) return;
  writeStored({ ...readStored(), ...found });
  window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash);
}

// { first_name, last_name, email, mobile } from the website form, if any
export function getPrefill() {
  const stored = { ...(window.__t2dPrefill || {}), ...readStored() };
  return {
    first_name: stored.first_name || "",
    last_name: stored.last_name || "",
    email: stored.email || "",
    mobile: stored.mobile || stored.phone_number || "",
  };
}

export function savePrefill(details) {
  writeStored({
    first_name: details.first_name || "",
    last_name: details.last_name || "",
    email: details.email || "",
    mobile: details.mobile || "",
  });
}
